const SERVICES_FILTER_ABORT_KEY = "__servicesFilterAbortController"

export const ServicesFilter = () => {
  const section = document.querySelector(".services-curated-section") as HTMLElement | null
  if (!section) return

  const host = section as HTMLElement & { [SERVICES_FILTER_ABORT_KEY]?: AbortController }
  host[SERVICES_FILTER_ABORT_KEY]?.abort()

  const abortController = new AbortController()
  host[SERVICES_FILTER_ABORT_KEY] = abortController
  const signal = abortController.signal

  const viewport = section.querySelector(".chips-viewport")
  const chipsContainer = section.querySelector(".service-category-chips") as HTMLElement | null
  if (!chipsContainer) return

  const applyFilter = (chip: HTMLElement) => {
    const allServicesTiles = document.querySelectorAll(".web-services-container .web-service-card.explore-tile")
    const value = chip.dataset.value ?? ""

    if (chip.dataset.kind === "filter") {
      if (value === "All") {
        allServicesTiles.forEach(tile => tile.classList.remove("hide"))
      } else {
        const tag = value.toLowerCase()
        allServicesTiles.forEach(tile => {
          // data-tags is comma-joined (see explore_helper#service_tile_wrapper),
          // so match per tag like the server-side visibility check does.
          const tags = ((tile as HTMLElement).dataset.tags ?? "").toLowerCase().split(",")
          if (tags.includes(tag)) {
            tile.classList.remove("hide")
          } else {
            tile.classList.add("hide")
          }
        })
      }
    } else {
      allServicesTiles.forEach(tile => {
        if ((tile as HTMLElement).dataset.category == value) {
          tile.classList.remove("hide")
        } else {
          tile.classList.add("hide")
        }
      })
    }

    section.querySelectorAll(".service-category-chip").forEach(other => {
      other.classList.toggle("active", other === chip)
      other.setAttribute("aria-pressed", String(other === chip))
    })

    const filterQueryParam = value.toLowerCase().split(/\W+/).join("-")
    let url = section.dataset.serviceBaseUrl
    if (filterQueryParam !== "all" && url) {
      url += `/${filterQueryParam}`
    }
    if (url) {
      window.history["replaceState"]({ url }, "", url)
    }
  }

  chipsContainer.addEventListener(
    "click",
    event => {
      const chip = (event.target as HTMLElement).closest(".service-category-chip") as HTMLElement | null
      if (chip) applyFilter(chip)
    },
    { signal },
  )

  section.querySelectorAll(".chips-arrow").forEach(arrow => {
    arrow.addEventListener(
      "click",
      () => {
        chipsContainer.scrollBy({
          left: Number((arrow as HTMLElement).dataset.direction) * chipsContainer.clientWidth * 0.8,
          behavior: "smooth",
        })
      },
      { signal },
    )
  })

  // The right-edge fade signals more chips; drop it once fully scrolled.
  const updateFade = () => {
    const atEnd = chipsContainer.scrollLeft + chipsContainer.clientWidth >= chipsContainer.scrollWidth - 1
    viewport?.classList.toggle("scrolled-to-end", atEnd)
  }

  chipsContainer.addEventListener("scroll", updateFade, { signal, passive: true })
  updateFade()
}
